module.exports = __webpack_public_path__ + "static/carpet-court-d76e7b68bc182523b37a47559488a8e2.jpg";